var themeOptions = function () { return ({
    components: {
        MuiFormControl: {
            defaultProps: {
                // MUI _does_ allow setting the component prop on FormControl, TS is just not properly configured to know it here in default props
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                component: 'fieldset',
            },
            styleOverrides: {
                root: {
                    legend: { marginBottom: '4px' },
                    '.MuiIconButton-root': {
                        cursor: 'default',
                    },
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=formControlTheme.js.map